import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyDFAMuiopn4gV2N9iwWN1UDGK39CKkUBLA",
  authDomain: "arcatalogue-9af3e.firebaseapp.com",
  databaseURL: "https://arcatalogue-9af3e.firebaseio.com",
  projectId: "arcatalogue-9af3e",
  storageBucket: "arcatalogue-9af3e.appspot.com",
  messagingSenderId: "907139485151",
  appId: "1:907139485151:web:113fdd6569ce0205f3486a",
  measurementId: "G-5ZEN8RZVCC"
};

export default async function initFirebase() {
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);

    /*   if (process.env.NODE_ENV === 'development') {
      firebase.firestore().settings({ host: 'localhost:8080', ssl: false });
      firebase.functions().useFunctionsEmulator('http://localhost:5001');
    }  */
  }
}
